module.exports = __webpack_public_path__ + "static/img/advantage2.95b8462.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/main/advantage2.png
// module id = Qz5C
// module chunks = 11